import { connect } from 'react-redux';
import { AssetPreview } from '../ui';
import { getAssetToPreview } from './reducers';

const container = connect(state => ({
  asset: getAssetToPreview(state),
}));

export default container(AssetPreview);
